import { ErrorHandler } from '@angular/core';

export class CustomErrorHandler extends ErrorHandler {
  handleError(_error: any): void {
    // Custom error handling logic heres
    // You can add your own error handling logic, such as logging or displaying messages to the user.
  }
}